// extracted by css-extract-rspack-plugin
export default {"AddAggregationButtonRoot":"zwcLI"};